<template>
	<div class="detrusion">
		<div class="title">样本管理 _出库</div>
		<div class="detrusion-main">
			<div class="dtree-select">
				<a-tree-select
						:getPopupContainer="triggerNode => triggerNode.parentNode"
						style="width: 100%"
						:value="value"
						:dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
						placeholder='请选择'
						allowClear
						treeDefaultExpandAll
						@change="onChange"
				>
					<a-tree-select-node v-for="(item) in treeExpandedKeys" :selectable="false"
					                    :value="item.deptId"
					                    :title="item.deptName"
					                    :key="item.deptId">
						<a-tree-select-node v-for="(cItem) in item.children"
						                    :value="cItem.deptId"
						                    :title="cItem.deptName"
						                    :key="cItem.deptId"/>
					</a-tree-select-node>

				</a-tree-select>
			</div>
			<a-button type="primary" @click="detrusionSubmit" class="confirm-primary">确定</a-button>
		</div>
	</div>
</template>

<script>

    export default {
        props: {
            list: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                data: this.list,
                treeExpandedKeys: [],
                value: undefined,
            }
        },
        mounted() {
            this.$get("dept/findDeptTreeList").then(
                res => {
                    if (res.data.data) {
                        this.treeExpandedKeys = res.data.data;
                    }
                },
                err => {
                    console.log('err', err);
                }
            );
        },
        methods: {
            detrusionSubmit() {
                if (this.data.length == 0) {
                    this.$message.error('请选择样本信息');
                } else if (this.value == undefined) {
                    this.$message.error('请选择流转机构');
                } else {
                    const dataVo = {
                        deptId: this.value,
                        idList: [],
                    };
                    this.data.forEach(function (item, i) {
                        dataVo.idList.push(item.id);
                    })
                    this.$post("sampleinfo/deliveryBatch", dataVo,
                        {
                            "Content-Type": "application/json"
                        }).then(
                        res => {
                            if (res.data.code == 1) {
                                this.$message.success("样本出库成功!");
                                this.$emit('clearSelected');
                            } else {
                                this.$message.error(res.data.message);
                            }
                            this.$emit("close");
                        },
                        error => {
                            console.log(error);
                            this.$message.error("样本出库失败!");
                        });
                }
            },
            onChange(value) {
                this.value = value.toString();
            },
        },
    }

</script>

<style lang="scss" scoped>
	.detrusion {
		.title {
			padding: 82px 0 56px 0;
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}
		.detrusion-main {
			width: 510px;
			margin: 0 auto;
		}

		.dtree-select {
			height: 350px;
		}
	}
</style>